<template>
  <div v-if="loggedin" class="page--beauty-profile new-form">
    <div class="maincontent registerpage">
      <ProgressBar class="progress--register" :progress-bar-width="progressBarWidth" />

      <section id="sign-in-steps" class="content" :class="{ newsletter: step == 4, 'beauty-profiles-steps': step < 4 }">
        <div class="maincontent-head">
          <div v-show="step === 1">
            <h5 class="heading">Beauty Profile</h5>
            <p class="copywriting">
              Lengkapi beauty profile Anda untuk mendapatkan rekomendasi produk dan konten dari kami.
            </p>
          </div>

          <div v-show="step === 3">
            <h5 class="heading">My Interest</h5>
            <p class="copywriting">
              Beritahu kami apa yang kamu sukai untuk rekomendasi artikel dan video yang lebih<br
                class="hide-desktop"
              />
              personal
            </p>
          </div>
        </div>
        <form method="post" @submit.prevent="validateBeforeSubmit">
          <div v-if="Object.keys(beautyField).length && Object.keys(listInterests).length">
            <section v-show="step === 1" id="step1" class="beauty-profile-section">
              <!-- warna kulit -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Warna Kulit</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div
                      v-for="warnakulit in beautyField['warna-kulit']"
                      :key="warnakulit._id"
                      class="option new-radio"
                    >
                      <img :src="warnakulit.image" width="80" height="80" />
                      <p>
                        {{
                          warnakulit.name.toLowerCase().charAt(0).toUpperCase() + warnakulit.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data['warna-kulit']"
                        v-validate="'required'"
                        type="radio"
                        class="radio"
                        name="warnakulit"
                        :value="warnakulit._id"
                        :class="{ haserror: errors.has('warnakulit') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('warnakulit')" class="alert topright">{{ errors.first('warnakulit') }}</p>
                </div>
              </div>
              <!-- warna kulit -->

              <!-- undertone -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Undertone</span>
                    <span class="info"
                      >Apa itu undertone?
                      <a
                        href=""
                        title="Learn more"
                        class="loadmodal"
                        modal="undertone-modal"
                        @click.prevent="showUndertoneModal = true"
                      >
                        Learn more
                      </a>
                    </span>
                  </span>
                </p>
                <GModal v-if="showUndertoneModal" id="undertone-modal" class="custom-modal modal-mask modal--undertone">
                  <template slot="header">
                    <h4 class="modal-heading">Apa itu Undertone ?</h4>
                  </template>
                  <template slot="body">
                    <ul class="row">
                      <li class="col-4">
                        <img src="/assets/img/undertone-cool.svg" width="50" height="50" />
                        <p class="text-center">Cool</p>
                      </li>
                      <li class="col-4">
                        <img src="/assets/img/undertone-neutral.svg" width="80" height="50" />
                        <p class="text-center">Neutral</p>
                      </li>
                      <li class="col-4">
                        <img src="/assets/img/undertone-warm.svg" width="50" height="50" />
                        <p class="text-center">Warm</p>
                      </li>
                    </ul>
                    <p>
                      Warna dasar kulit yang umumnya bisa ditentukan dari warna urat nadi di pergelangan tangan. Jika
                      berwarna kebiruan, undertone kamu adalah Cool.<br /><br />Jika berwarna kehijauan, undertone kamu
                      adalah Warm. Jika berwarna perpaduan kebiruan dan kehijauan, undertone kamu adalah Netral.
                    </p>
                    <a href="" class="btn red" @click.prevent="showUndertoneModal = false"> Ok </a>
                  </template>
                </GModal>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div v-for="undertone in beautyField.undertone" :key="undertone._id" class="option new-radio">
                      <img height="80" :src="undertone.image" :width="undertone.name === 'Neutral' ? 90 : 80" />
                      <p>
                        {{
                          undertone.name.toLowerCase().charAt(0).toUpperCase() + undertone.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data.undertone"
                        v-validate="'required'"
                        type="radio"
                        class="radio"
                        name="undertone"
                        :value="undertone._id"
                        :class="{ haserror: errors.has('undertone') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('undertone')" class="alert topright">{{ errors.first('undertone') }}</p>
                </div>
              </div>
              <!-- undertone -->

              <!-- jenis kulit -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Jenis Kulit</span>
                    <span class="info">Kamu bisa memilih lebih dari satu</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div
                      v-for="(jeniskulit, index) in beautyField['jenis-kulit']"
                      :ref="`option-${index}`"
                      :key="jeniskulit._id"
                      class="option"
                    >
                      <img :src="jeniskulit.image" width="80" height="80" />
                      <div class="option-text">
                        <p style="padding: 0px 20px">
                          {{
                            jeniskulit.name.toLowerCase().charAt(0).toUpperCase() +
                            jeniskulit.name.toLowerCase().slice(1)
                          }}
                        </p>
                        <!-- eslint-disable vue/no-use-v-if-with-v-for -->
                        <span
                          v-for="(tooltips, key) in skinTypeTooltip"
                          v-if="jeniskulit.name == tooltips.name"
                          :key="key"
                          v-tooltip.bottom-start="tooltipOption(tooltips, index)"
                          style="white-space: pre-line"
                          class="desc"
                          @click="openTooltip(tooltips)"
                        >
                        </span>
                        <!-- eslint-enable vue/no-use-v-if-with-v-for -->
                      </div>
                      <input
                        v-model="data['jenis-kulit']"
                        v-validate="'required'"
                        type="checkbox"
                        class="checkbox"
                        name="jeniskulit"
                        :value="jeniskulit._id"
                        :class="{ haserror: errors.has('jeniskulit') }"
                        :disabled="data['jenis-kulit'].length > 2 && data['jenis-kulit'].indexOf(jeniskulit._id) === -1"
                      />

                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('jeniskulit')" class="alert topright">{{ errors.first('jeniskulit') }}</p>
                </div>
              </div>
              <!-- jenis kulit -->

              <!-- kondisi kulit -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Kondisi Kulit</span>
                    <span class="info">Kamu bisa memilih lebih dari satu</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div v-for="kondisikulit in beautyField['kondisi-kulit']" :key="kondisikulit._id" class="option">
                      <img :src="kondisikulit.image" width="80" height="80" />
                      <p style="padding: 0 20px">
                        {{
                          kondisikulit.name.toLowerCase().charAt(0).toUpperCase() +
                          kondisikulit.name.toLowerCase().slice(1)
                        }}
                        <span v-if="dates < kondisikulit.created_at" class="new-btn">New</span>
                      </p>
                      <input
                        v-model="data['kondisi-kulit']"
                        v-validate="'required'"
                        type="checkbox"
                        class="checkbox"
                        name="kondisikulit"
                        :value="kondisikulit._id"
                        :class="{ haserror: errors.has('kondisikulit') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('kondisikulit')" class="alert topright">{{ errors.first('kondisikulit') }}</p>
                </div>
              </div>
              <!-- kondisi kulit -->

              <!-- bentuk wajah -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Bentuk Wajah</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div
                      v-for="bentukwajah in beautyField['bentuk-wajah']"
                      :key="bentukwajah._id"
                      class="option new-radio"
                    >
                      <img :src="bentukwajah.image" height="80" />
                      <p>
                        {{
                          bentukwajah.name.toLowerCase().charAt(0).toUpperCase() +
                          bentukwajah.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data['bentuk-wajah']"
                        v-validate="'required'"
                        type="radio"
                        class="radio"
                        name="bentukwajah"
                        :value="bentukwajah._id"
                        :class="{ haserror: errors.has('bentukwajah') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('bentukwajah')" class="alert topright">{{ errors.first('bentukwajah') }}</p>
                </div>
              </div>
              <!-- bentuk wajah -->
            </section>

            <section v-show="step === 2" id="step2" class="beauty-profile-section">
              <!-- warna rambut -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Warna Rambut</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div
                      v-for="warnarambut in beautyField['warna-rambut']"
                      :key="warnarambut._id"
                      class="option new-radio"
                    >
                      <img :src="warnarambut.image" width="80" height="80" />
                      <p>
                        {{
                          warnarambut.name.toLowerCase().charAt(0).toUpperCase() +
                          warnarambut.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data['warna-rambut']"
                        v-validate="'required'"
                        type="radio"
                        class="radio"
                        name="warnarambut"
                        :value="warnarambut._id"
                        :class="{ haserror: errors.has('warnarambut') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('warnarambut')" class="alert topright">{{ errors.first('warnarambut') }}</p>
                </div>
              </div>
              <!-- warna rambut -->

              <!-- panjang rambut -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Panjang Rambut</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div
                      v-for="panjangrambut in beautyField['panjang-rambut']"
                      :key="panjangrambut._id"
                      class="option new-radio"
                    >
                      <img :src="panjangrambut.image" height="80" />
                      <p>
                        {{
                          panjangrambut.name.toLowerCase().charAt(0).toUpperCase() +
                          panjangrambut.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data['panjang-rambut']"
                        v-validate="'required'"
                        type="radio"
                        class="radio"
                        name="panjangrambut"
                        :value="panjangrambut._id"
                        :class="{ haserror: errors.has('panjangrambut') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('panjangrambut')" class="alert topright">{{ errors.first('panjangrambut') }}</p>
                </div>
              </div>
              <!-- panjang rambut -->

              <!-- jenis rambut -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Jenis Rambut</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div
                      v-for="jenisrambut in beautyField['jenis-rambut']"
                      :key="jenisrambut._id"
                      class="option new-radio"
                    >
                      <img :src="jenisrambut.image" width="80" height="80" />
                      <p>
                        {{
                          jenisrambut.name.toLowerCase().charAt(0).toUpperCase() +
                          jenisrambut.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data['jenis-rambut']"
                        v-validate="'required'"
                        type="radio"
                        class="radio"
                        name="jenisrambut"
                        :value="jenisrambut._id"
                        :class="{ haserror: errors.has('jenisrambut') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('jenisrambut')" class="alert topright">{{ errors.first('jenisrambut') }}</p>
                </div>
              </div>
              <!-- jenis rambut -->

              <!-- kondisi rambut -->
              <div class="items">
                <p class="title">
                  <span class="wrapper">
                    <span>Kondisi Rambut</span>
                    <span class="info">Kamu bisa memilih lebih dari satu</span>
                  </span>
                </p>
                <div class="container options">
                  <div class="row row-no-padding">
                    <div v-for="kondisirambut in beautyField['kondisi-rambut']" :key="kondisirambut._id" class="option">
                      <img :src="kondisirambut.image" width="80" height="80" />
                      <p>
                        {{
                          kondisirambut.name.toLowerCase().charAt(0).toUpperCase() +
                          kondisirambut.name.toLowerCase().slice(1)
                        }}
                      </p>
                      <input
                        v-model="data['kondisi-rambut']"
                        v-validate="'required'"
                        type="checkbox"
                        class="checkbox"
                        name="kondisirambut"
                        :value="kondisirambut._id"
                        :class="{ haserror: errors.has('kondisirambut') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                  <p v-show="errors.has('kondisirambut')" class="alert topright">{{ errors.first('kondisirambut') }}</p>
                </div>
              </div>
              <!-- kondisi rambut -->
            </section>

            <section v-show="step === 3" id="step3" class="beauty-profile-section">
              <div class="items">
                <div class="container options custom-scroll">
                  <div class="row row-no-padding">
                    <div v-for="(interest, i) in listInterests" :key="i" class="option">
                      <img :src="interest.image" width="80" height="80" />
                      <p>
                        {{ interest.name.toLowerCase().charAt(0).toUpperCase() + interest.name.toLowerCase().slice(1) }}
                        <span v-if="interest.is_new" class="new-btn">New</span>
                      </p>
                      <input
                        v-model="data.interest"
                        v-validate="'required'"
                        type="checkbox"
                        class="checkbox"
                        name="interest"
                        :value="interest"
                        :class="{ haserror: errors.has('interest') }"
                      />
                      <div class="overlay"></div>
                    </div>
                  </div>
                </div>
                <p v-show="errors.has('interest')" class="alert topright">{{ errors.first('interest') }}</p>
              </div>
            </section>

            <div v-if="step <= 3" class="beauty-profile-section">
              <div class="beauty-profile--button button-group-inline">
                <button
                  v-if="!loading"
                  type="button"
                  class="btn red"
                  :class="{ disabled: !isStepActive }"
                  :disabled="!isStepActive"
                  @click.prevent="nextStep"
                >
                  Next
                </button>
                <GLoaderSpin v-else></GLoaderSpin>
              </div>
            </div>

            <NewsletterModal
              v-if="isShowModalNewsletter"
              :allow-fetch-newsletter="allowFetchNewsletter"
              @back="closeNewsletter"
              @after-submit="afterSubmitNewsletter"
            ></NewsletterModal>
          </div>

          <GLoaderSpin v-else :text="'Memuat beauty profile...'" />
        </form>
      </section>
    </div>
    <ModalDiscard
      v-if="showDiscardModal"
      :message="discardMessage"
      :title="discardTitle"
      @discard="discardModal()"
      @close="toggleDiscardModal()"
    />
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
import Auth from '@/shared/auth';
import { mapGetters } from 'vuex';

export default {
  name: 'BeautyProfile',
  components: {
    NewsletterModal: () => import('@/components/global/modal/modal-newsletter'),
    ModalDiscard: () => import('@/components/global/modal/modal-discard'),
  },
  data() {
    return {
      allowFetchNewsletter: false,
      beautyField: {},
      data: {
        'warna-kulit': '',
        undertone: '',
        'jenis-kulit': [],
        'kondisi-kulit': [],
        'bentuk-wajah': '',
        'warna-rambut': '',
        'panjang-rambut': '',
        'jenis-rambut': '',
        'kondisi-rambut': [],
        interest: [],
        newsletter: [1, 2, 3, 4],
      },
      dates: '',
      listInterests: '',
      isShowModalNewsletter: false,
      loading: false,
      showUndertoneModal: false,
      skinTypeTooltip: [
        {
          name: 'Kulit Normal',
          value: `- kulit cenderung sehat dan kenyal <br> - pori-pori terlihat normal`,
          isOpen: false,
        },
        {
          name: 'Kulit Kering',
          value: `- mudah bersisik <br> - cenderung memiliki garis halus`,
          isOpen: false,
        },
        {
          name: 'Kulit Berminyak',
          value: `- cenderung memiliki komedo <br> - terlihat mengkilap dan berminyak <br> - pori-pori terlihat besar`,
          isOpen: false,
        },
        {
          name: 'Kulit Kombinasi',
          value: `- berminyak di area T-Zone <br> - normal atau kering di sebagian area`,
          isOpen: false,
        },
        {
          name: 'Kulit Sensitif',
          value: `- mudah kemerahan <br> - reaktif saat mencoba produk baru`,
          isOpen: false,
        },
      ],
      nextRoute: '',
      doneSubmitNewsletter: false,
      discardTitle: 'Discard',
      discardMessage: 'Apakah kamu ingin membatalkan untuk melengkapi beauty profile?',
      forceLeave: false,
    };
  },
  created() {
    this.fetchBeautyProfile();
    this.fetchBeautyInterest();
    this.$store.commit('setBeautyProfileStep', 1);
  },
  methods: {
    discardModal() {
      this.$router.push('/');
      this.toggleDiscardModal();
    },
    toggleDiscardModal() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'discardModal' });
    },
    afterSubmitNewsletter() {
      this.forceLeave = true;
      this.isSubmitNewsletterProcessing = true;
      this.$store.dispatch('submitBeautyProfile').then((success) => {
        if (success) {
          Auth.me().then(() => {
            this.isShowModalNewsletter = false;
            this.isSubmitNewsletterProcessing = false;
            this.doneSubmitNewsletter = true;
            this.$toasted.global.show('Terima kasih telah melengkapi Beauty Profile kamu');
            if (this.$route.name == 'BeautyProfile') {
              this.$router.push('/recommendation');
            }
          });
        }
      });
    },
    closeNewsletter() {
      this.isShowModalNewsletter = false;
    },
    fetchBeautyProfile() {
      axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + '/tags?type=beauty-profile')
        .then((response) => {
          const beauty = response.data.data || [];
          const date = new Date(2020, 4, 1, 23, 59);
          this.beautyField = beauty.reduce((result, current) => {
            result[current.code] = current.subtags;
            return result;
          }, {});
          this.dates = date.toISOString();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchBeautyInterest() {
      axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + '/tags?type=beauty-interest')
        .then((response) => {
          if (response.status === 200) {
            this.listInterests = response.data.data[0].subtags;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nextStep() {
      if (this.step === 1) {
        this.skinTypeTooltip.map((res) => (res.isOpen = false));
        this.step++;
        this.$store.commit('setBeautyProfileStep', this.step);
        setTimeout(() => {
          this.scrollToTop();
        }, 150);
      } else if (this.step === 2) {
        this.step++;
        Auth.registerProfile(this).then((res) => {
          if (res === true && this.user && Object.keys(this.user).length) {
            Auth.beautyProfile(this.user);
          }
        });
        this.$store.commit('setBeautyProfileStep', this.step);
        this.scrollToTop();
      } else if (this.step === 3) {
        this.saveInterest({ showNewsletter: true });
      } else if (this.step === 4) {
        this.isShowModalNewsletter = true;
      }
    },
    onScrollModal(direction) {
      if (direction === 'top') {
        document.querySelector('#modal--bp .content').scrollTo(0, 0);
      }
      if (direction === 'bottom') {
        const content = document.querySelector('#modal--bp .content');
        content.scrollTop = content.offsetTop + 500;
      }
    },
    openTooltip(tooltips) {
      this.skinTypeTooltip.map((res) => (res.isOpen = false));
      tooltips.isOpen = !tooltips.isOpen;
    },
    saveInterest({ showNewsletter }) {
      this.loading = true;
      Promise.all([this.$validator.validate('interest')]).then((response) => {
        const [isPassed] = response;
        if (isPassed) {
          const params = [];

          params.push({
            type: 'beauty-interest',
            name: 'favourite_topics',
            code: 'favourite-topics',
            subtags: this.data.interest,
          });

          Auth.registerInterest(params)
            .then(() => {
              if (showNewsletter) {
                this.showNewsletter();
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    showNewsletter() {
      this.$store.dispatch('fetchNewsletter', this).then(() => {
        if (!this.isSubscribingsSet) {
          this.allowFetchNewsletter = false;
          this.isShowModalNewsletter = true;
        } else {
          this.afterSubmitNewsletter();
        }
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    tooltipOption(tooltips, index) {
      const options = {
        content: tooltips.name + '<br>' + tooltips.value,
        show: tooltips.isOpen,
        trigger: 'manual',
      };
      return options;
    },
    validateBeforeSubmit(e) {},
    discard() {
      if (this.nextRoute) {
        this.nextRoute();
        this.nextRoute = '';
      }
    },
  },
  computed: {
    ...mapGetters(['isFemale', 'hasLillaProfile']),
    showDiscardModal() {
      return this.$store.state.modal.isModalShow.discardModal;
    },
    meCalled() {
      return this.$store.state.auth.meCalled;
    },
    loggedin() {
      return this.$store.state.auth.loggedin;
    },
    isSubmitNewsletterProcessing: {
      get() {
        return this.$store.state.profile.newsletterLoading;
      },
      set(value) {
        this.$store.commit('newsletterLoading', value);
      },
    },
    isSubscribingsSet() {
      return this.$store.state.profile.newsletterSet;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    isStepActive() {
      if (this.step === 1) {
        return (
          Boolean(this.data['warna-kulit']) &&
          Boolean(this.data['undertone']) &&
          $SO.size(this.data['jenis-kulit']) &&
          $SO.size(this.data['kondisi-kulit']) &&
          Boolean(this.data['bentuk-wajah'])
        );
      } else if (this.step === 2) {
        return (
          Boolean(this.data['warna-rambut']) &&
          Boolean(this.data['panjang-rambut']) &&
          Boolean(this.data['jenis-rambut']) &&
          $SO.size(this.data['kondisi-rambut'])
        );
      } else if (this.step === 3) {
        return $SO.size(this.data['interest']);
      } else if (this.step === 4) {
        return (
          this.$store.state.lilla.data.total_children ===
          $SO.size(
            this.$store.state.lilla.data.children.filter((dt) =>
              Object.values(dt).every((key) => dt['name'] && dt['year_of_birth'])
            )
          )
        );
      }
    },
    progressBarWidth() {
      return (this.step / this.totalSteps) * 100 + '%';
    },
    step: {
      get() {
        return this.$store.state.profile.beautyProfileStep.current;
      },
      set(value) {
        this.$store.commit('setBeautyProfileStep', value);
      },
    },
    totalSteps() {
      return this.$store.state.profile.beautyProfileStep.total;
    },
    user() {
      return this.$store.state.auth && this.$store.state.auth.userProfile ? this.$store.state.auth.userProfile : null;
    },
  },
  watch: {
    meCalled: {
      handler(newVal) {
        if (newVal && !this.loggedin) {
          this.$router.push('/');
        }
      },
      immediate: true,
    },
    showDiscardModal(newVal) {
      if (!newVal) {
        this.forceLeave = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    // next(vm => {
    //     if (!vm.$store.state.auth.loggedin) {
    //         next({path: '/'})
    //     }
    // })
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.forceLeave) {
      next(false);
      this.toggleDiscardModal();
      this.forceLeave = true;
    } else {
      next();
    }
  },
};
</script>

<style lang="scss">
@import 'beauty-profile';
</style>
